import { useState } from 'react';
import { Paper, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

export default function StakeCard({currency}) {
  const [selectedDuration, setSelectedDuration] = useState(7);
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleStake = () => {
    navigate('/dashboard/support-tickets');
  };

  return (
    <Paper elevation={0} className="card stake-card">
      
      <div className="stake-header">
        <div className="stake-card-icon">
          {currency.icon}
        </div>
        <Typography variant="h6" className="stake-title">{currency.name}</Typography>
      </div>

      
      <div className="duration-section">
        <Typography className="duration-label">{t('duration')}</Typography>
        <div className="duration-buttons">
          <Button 
            className={`duration-button ${selectedDuration === 7 ? 'active' : ''}`}
            onClick={() => setSelectedDuration(7)}
          >
            {t('days7')}
          </Button>
          <Button 
            className={`duration-button ${selectedDuration === 14 ? 'active' : ''}`}
            onClick={() => setSelectedDuration(14)}
          >
            {t('days14')}
          </Button>
          <Button 
            className={`duration-button full-width ${selectedDuration === 30 ? 'active' : ''}`}
            onClick={() => setSelectedDuration(30)}
          >
            {t('days30')}
          </Button>
        </div>
      </div>

      
      <div className="info-rows">
        <div className="info-row">
          <Typography className="info-label">{t('rate')}</Typography>
          <Typography className="info-value">2.70%</Typography>
        </div>
        <div className="info-row">
          <Typography className="info-label">{t('minValue')}</Typography>
          
          <Typography className="info-value">0.0116986813 {currency.symbol}</Typography>
        </div>
        <div className="info-row">
          <Typography className="info-label">{t('maxValue')}</Typography>
          
          <Typography className="info-value">2.2227494428 {currency.symbol}</Typography>
        </div>
      </div>

      {/* Кнопка действия */}
      <Button fullWidth variant="contained" className="action-button" onClick={handleStake}>
        {t('stake')}
      </Button>
    </Paper>
  );
}